export default __webpack_public_path__ + "static/media/work-plan-2.b324118a.svg";